// 3D-Icon-Set (Kundenwunsch) – konsistente Clay/Cream-3D-Icons auf weißem Grund.
// Schlüssel = Amenity-ID, semantischer Name oder Lucide-Name (Alias).
export const ICON_3D: Record<string, string> = {
  // Ausstattung / Bento
  kitchen: "/icons/kitchen.png",
  wifi: "/icons/wifi.png",
  singlebeds: "/icons/bed.png",
  bed: "/icons/bed.png",
  rooms: "/icons/rooms.png",
  bath: "/icons/shower.png",
  parking: "/icons/parking.png",
  cleaning: "/icons/cleaning.png",
  allinclusive: "/icons/euro.png",
  checkout: "/icons/clock.png",
  quiet: "/icons/shield.png",
  fridge: "/icons/fridge.png",
  stove: "/icons/stove.png",
  oven: "/icons/oven.png",
  microwave: "/icons/microwave.png",
  dishes: "/icons/dishes.png",
  coffee: "/icons/coffee.png",
  // Kontakt
  phone: "/icons/phone.png",
  mail: "/icons/mail.png",
  pin: "/icons/pin.png",
  // Lage & Umgebung (Alias = Lucide-Name der Gruppen)
  Footprints: "/icons/walk.png",
  UtensilsCrossed: "/icons/restaurant.png",
  Landmark: "/icons/landmark.png",
  Trees: "/icons/trees.png",
  TrainFront: "/icons/train.png",
  Plane: "/icons/plane.png",
  // Für wen (Zielgruppen)
  hardhat: "/icons/hardhat.png",
  briefcase: "/icons/briefcase.png",
  users: "/icons/users.png",
};

type Size = "xs" | "sm" | "md" | "lg";
const box: Record<Size, string> = { xs: "h-9 w-9", sm: "h-12 w-12", md: "h-14 w-14", lg: "h-16 w-16" };

/** Einheitliches 3D-Icon. Reagiert beim Hover der Elternkarte (group) mit leichtem Zoom. */
export const Icon3D = ({ src, size = "md", className = "" }: { src: string; size?: Size; className?: string }) => (
  <img
    src={src}
    alt=""
    aria-hidden
    draggable={false}
    loading="lazy"
    className={`${box[size]} shrink-0 select-none object-contain transition-transform duration-300 ease-out group-hover:-translate-y-0.5 group-hover:scale-110 ${className}`}
  />
);
